<!--
  Визуальная часть trigger BaseSelect: label выбранной опции, цветная метка,
  иконки поиска/загрузки/выбора и поле inline-search. Компонент не выбирает
  option и не ищет данные: этим по-прежнему управляет BaseSelect.
-->
<template>
  <template v-if="inlineSearch">
    <span
      v-if="selectedOption?.color && !inlineSearchIsActive"
      class="select-color-dot"
      :style="{ backgroundColor: selectedOption.color }"
    ></span>
    <span
      v-if="inlineSearchIsActive"
      class="selected-value__search-icon"
    >
      <span
        v-if="inlineSearchLoading"
        class="selected-value__loading-indicator"
        role="status"
        aria-label="Загрузка результатов поиска"
      ></span>
      <AppIcon v-else name="search" :size="14" />
    </span>
    <span
      v-else-if="selectedOption"
      class="selected-value__status-icon"
      title="Выбран элемент из списка"
    >
      <AppIcon name="check" :size="14" />
    </span>
    <input
      ref="inlineSearchInput"
      :value="searchQuery"
      class="selected-value__input"
      type="text"
      :placeholder="inlineSearchPlaceholder"
      :disabled="disabled"
      @click.stop="$emit('click')"
      @focus="$emit('focus')"
      @input="handleInput"
      @mousedown="$emit('mousedown')"
      @keydown.stop="$emit('keydown', $event)"
    >
  </template>
  <template v-else>
    <span
      v-if="selectedOption?.color"
      class="select-color-dot"
      :style="{ backgroundColor: selectedOption.color }"
    ></span>
    <span class="selected-value__text">
      {{ selectedOption?.label || placeholder }}
    </span>
  </template>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseSelectValue",

  components: {
    AppIcon,
  },

  props: {
    selectedOption: {
      type: Object,
      default: null,
    },
    inlineSearch: {
      type: Boolean,
      default: false,
    },
    inlineSearchIsActive: {
      type: Boolean,
      default: false,
    },
    inlineSearchLoading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
    inlineSearchPlaceholder: {
      type: String,
      default: "Поиск",
    },
    placeholder: {
      type: String,
      default: "Выберите опцию",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["click", "focus", "input", "mousedown", "keydown"],

  methods: {
    focusInput() {
      this.$refs.inlineSearchInput?.focus();
    },

    handleInput(event) {
      this.$emit("input", event);
    },
  },
};
</script>

<style scoped>
.select-color-dot {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 50%;
}

.selected-value__text {
  display: block;
  min-width: 0;
  line-height: 1.45;
  overflow: hidden;
  padding-block: 2px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-value__input {
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-text-primary, #111827);
  font: inherit;
  line-height: 1.45;
  outline: none;
}

.selected-value__search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #999;
}

.selected-value__loading-indicator {
  width: 14px;
  height: 14px;
  border: 2px solid #cbd5e1;
  border-top-color: var(--color-green);
  border-radius: 50%;
  animation: base-select-spin 0.7s linear infinite;
  box-sizing: border-box;
}

@keyframes base-select-spin {
  to {
    transform: rotate(360deg);
  }
}

.selected-value__status-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--color-green);
  color: #fff;
}

.selected-value__input::placeholder {
  color: #999;
}
</style>
